module.exports = __webpack_public_path__ + "/images/ico-color-labels.70c29b9.svg";